package com.myfield.app.components.sections

import androidx.compose.runtime.Composable
import com.myfield.app.style.TextSelectionStyle
import com.myfield.app.util.Constants.ACME_REGULAR
import com.myfield.app.util.Theme
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P

@Composable
fun Header(
    largeBreakpoint: Boolean,
) {
    Row(
        modifier = Modifier
            .fillMaxWidth()
            .padding(
                top = 25.px,
                bottom = if (largeBreakpoint) 0.px else 50.px
            ),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.Center
    ) {
        /*      Image(
                  modifier = LogoStyle.toModifier()
                      .size(size = 60.px)
                      //.clip(RectF(cornerRadius = 16.px))
                      .cursor(Cursor.Pointer)
                      .margin(right = 12.px),
                  src = Resource.Icon.LOGO,
                  alt = "Logo Image"
              )*/
        P(
            attrs = TextSelectionStyle.toModifier()
                .color(Theme.Text.rgb)
                .fontFamily(ACME_REGULAR)
                .fontSize(if (largeBreakpoint) 2.cssRem else 1.8.cssRem)
                .lineHeight(value = if (largeBreakpoint) 1.6 else 1.4)
                .margin(right = 6.px)
                .toAttrs()
        ) {
//            Text(
            SpanText(
                modifier = Modifier.color(Theme.Primary.rgb),
                text = "My Field"
            )
            //          )
        }
    }
}
